/**
 * Story "Read more" modal — ouvre/ferme la modal du contenu complet (story_full).
 * Bouton [data-story-open] → ouvre le [data-story-modal] du même wrap.
 * Ferme via [data-story-close] (overlay/croix) ou Escape.
 */
(function () {
  function open(modal) {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = modal.querySelector('[data-story-close]');
    if (close) close.focus();
  }
  function close(modal) {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-story-open]');
    if (openBtn) {
      var wrap = openBtn.closest('.image-text-grid__readmore-wrap') || document;
      var modal = wrap.querySelector('[data-story-modal]');
      if (modal) open(modal);
      return;
    }
    var closeEl = e.target.closest('[data-story-close]');
    if (closeEl) {
      var m = closeEl.closest('[data-story-modal]');
      if (m) close(m);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-story-modal]:not([hidden])').forEach(close);
    }
  });
})();
